<template>
  <!-- Main Sidebar -->
  <a-layout-sider
    collapsible
    class="sider-primary"
    breakpoint="lg"
    collapsed-width="0"
    width="250px"
    :collapsed="sidebarCollapsed"
    @collapse="$emit('toggleSidebar', !sidebarCollapsed)"
    :trigger="null"
    :class="[
      'ant-layout-sider-' + sidebarColor,
      'ant-layout-sider-' + sidebarTheme,
    ]"
    theme="light"
    :style="{ backgroundColor: 'transparent' }"
  >
    <div class="brand">
      <img src="images/nb-b-logo.png" alt="" /> <span>天马年报</span>
    </div>
    <hr />

    <!-- Sidebar Navigation Menu -->
    <a-menu theme="light" mode="inline">
      <a-menu-item v-for="(item, index) in menuList" :key="index">
        <router-link :to="item.path">
          <span class="icon" v-html="item.svg"> </span>
          <span class="label">{{ item.title }}</span>
        </router-link>
      </a-menu-item>
    </a-menu>
  </a-layout-sider>
  <!-- / Main Sidebar -->
</template>

<script>
import storeRouter from "@/router/admin.js";
import { resetRouter } from "@/router";

export default {
  props: {
    // Sidebar collapsed status.
    sidebarCollapsed: {
      type: Boolean,
      default: false,
    },

    // Main sidebar color.
    sidebarColor: {
      type: String,
      default: "primary",
    },

    // Main sidebar theme : light, white, dark.
    sidebarTheme: {
      type: String,
      default: "light",
    },
  },
  data() {
    return {
      userInfo: {},
      menuList: [],
      // sidebarCollapsedModel: this.sidebarCollapsed,
    };
  },

  created() {
    this.userInfo =
      JSON.stringify(this.$store.getters.userInfo) == "{}"
        ? JSON.parse(localStorage.getItem("userInfo"))
        : this.$store.getters.userInfo;

    resetRouter();
    let menuList =
      JSON.parse(JSON.stringify(this.$router.options.routes)) || [];

    if (this.userInfo.grade == 1) {
      storeRouter.forEach((item) => {
        if (menuList.length > 1) {
          menuList.splice(menuList.length  - 2, 0, item);
        } else {
          menuList.push(item);
        }
        this.$router.addRoute(item);
      });
    }

    this.$store.dispatch("user/changeRoles", menuList);

    menuList.forEach((item) => {
      if (item.isMenu) {
        this.menuList.push(item);
      }
    });
  },
};
</script>
